import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetArticleListLoading, EGetArticleListActionType } from './types';

export const getArticleListLoading: () => TGetArticleListLoading = actionGenerator<EGetArticleListActionType.Loading>(
  EGetArticleListActionType.Loading,
);
